const resolveApiBase = () => {
    const env = process.env.NODE_ENV || 'development';

    if (env === 'production' && process.env.REACT_APP_API_BASE_URL_PROD) {
        return process.env.REACT_APP_API_BASE_URL_PROD;
    }
    if (process.env.REACT_APP_API_BASE_URL_DEV) {
        return process.env.REACT_APP_API_BASE_URL_DEV;
    }
    return '';
};

export default resolveApiBase;
